import apiInstance from '../../utils/axios/apiInstance';
import {encodeData} from '../../utils/url'

// Assign User to Job
export const assignUserTaskService = (data: object) => {
    return apiInstance.post(`admin/tasks`, data);
}

// Assign User to Job
export const assignRequestTaskService = (data: object) => {
    return apiInstance.post(`admin/request-create-task`, data);
}

// Get Hr users
export const searchUsersByName = (role: string, name: string) => {
    const data = {
        name: name
    }
    const searchParams = encodeData(data);
    return apiInstance.get(`/admin/users/role/${role}?${searchParams}`);
}

// Get Tasks
export const getTasks = (data: object) => {
    const searchParams = encodeData(data);
    return apiInstance.get(`profile/tasks?${searchParams}`);
}

// Complete HR task
export const completingTask = (data: object, id: string) => {
    return apiInstance.patch(`profile/tasks/${id}`, data);
}

// Get Profile task
export const getTaskProfileService = (id: string) => {
    return apiInstance.get(`profile/tasks/${id}`);
}

// Approve Job
export const entityApproving = (id: string, data: object, model: string) => {
    return apiInstance.patch(`profile/approve-${model}/${id}`, data);
}

// Get Single Task For Admin
export const getTask = (id: string) => {
    return apiInstance.get(`profile/tasks/${id}`);
}

// Approve Job
export const jobNews = (id: string, data: object) => {
    return apiInstance.patch(`profile/approve-job/${id}`, data);
}

// Task Group
export const taskGroup = () => {
    return apiInstance.get(`profile/task-group`);
}

// Delete Task as Admin
export const deleteTaskService = (id: string) => {
    return apiInstance.delete(`admin/tasks/${id}`);
}

// Get Applicants
export const getAllApplicantionsService = (id: string, page?: number, per_page?: number) => {
    const data = {
        page: page,
        per_page: per_page
    }
    const params = encodeData(data);
    return apiInstance.get(`profile/job-applications-by-job/${id}?${params}`);
}


// CreatePriceForPreselection
export const createPriceService = (data: any) => {
    return apiInstance.post(`profile/bids`, data);
}

export const getJobCommentService = (id: string) => {
    return apiInstance.get(`profile/job-pre-selection-comment/${id}`);
}


